module.exports = __webpack_public_path__ + "static/media/email@2x.aec08982.svg";